// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"yY-z","subtitle":"zY-z","wrapper":"AY-z","leftArrow":"BY-z","rightArrow":"CY-z"};